<template>
<div>
    <validation-observer v-slot="{ invalid }">
        <b-form @submit.prevent="SimpanMaklumat" style="width:1000px;">
            <h3 class="mb-0">MAKLUMAT PENETAPAN GAJI KENAIKAN PANGKAT </h3>
            <br />
            <div class="pl-lg-2">


                <validation-provider name="Klasifikasi Perkhidmatan" :rules="{ required: true }" >
                    <b-row>
                        <b-col lg="3"> Klasifikasi Perkhidmatan</b-col>
                        <b-col lg="1"> :</b-col>
                        <b-col lg="4">
                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="Obj.ServClassId" :options="ServClassList" @change="runMethod()" style="width: 100%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Skim Perkhidmatan Tukar Lantik" :rules="{ required: true }" >
                    <b-row>
                        <b-col lg="3"> Skim Perkhidmatan</b-col>
                        <b-col lg="1"> :</b-col>
                        <b-col lg="6">
                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="Obj.SchmOfServId" :options="SchmOfServList"   style="width: 100%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-row class="my-1">
                    <b-col sm="1">&nbsp;</b-col>
                </b-row>
                <validation-provider name="pilih skim" :rules="{ required: true }">
                    <b-row>
                        <b-col lg="3"> Sistem Saraan * </b-col>
                        <b-col lg="1"> :</b-col>
                        <b-col lg="6">
                            <b-form-select id="Pilih Skim" name="Pilih Skim" value-field="value" text-field="text" :options="skimOptions" v-model="Obj.id_SistemSaraan" @change="runMethod2()" style="width: 45%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Gred Jawatan Tukar Lantik" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg="3"> Gred Jawatan</b-col>
                        <b-col lg="1">:</b-col>
                        <b-col lg="3">
                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="Obj.SalGrdID" :options="SalGrdList" style="width: 40%" aria-describedby="input-2-live-feedback">
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="AmaunTelahTerima" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg='3'>Amaun Dalam Buku Servis:</b-col>
                        <b-col lg='1'>:</b-col>
                        <b-col lg='2'>
                            <base-input type="text" v-model="Obj.AmaunTelahTerima"  />
                             
                        </b-col>
                    </b-row>
                </validation-provider>

                <validation-provider name="Catatan" :rules="{ required: true }" v-slot="validationContext">
                    <b-row>
                        <b-col sm="3"> Catatan </b-col>
                        <b-col sm="1"> :</b-col>
                        <b-col sm="8">
                            <!-- <b-form-input v-model="Obj.Catatan" :state="getValidation(validationContext)" class="custom-input"></b-form-input> -->
                            <b-form-textarea v-model="Obj.Catatan" class="custom-input" rows="4" maxlength="1000" ></b-form-textarea>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Tarikh Kuatkuasa" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                            <b-col lg='3'>Tarikh Kuatkuasa Gaji KENAIKAN PANGKAT* </b-col>
                            <b-col lg='1'>:</b-col>
                            <b-col lg='3'>
                                <base-input type="date" v-model="Obj.EftDate" />
                            </b-col>
                        </b-row>
                </validation-provider>
                <b-col>&nbsp;</b-col>
                <b-form-row>
                    <b-col>
                        <b-form-group>
                            <div>
                                <b-col>&nbsp;</b-col>
                                <b-col align="center">
                                    <b-button variant="success" type="submit">SIMPAN</b-button>
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="next()">KEMBALI</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">SETERUSNYA</b-button> -->
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="nextPapar()">PAGE PAPAR</b-button> -->

                                </b-col>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </div>
        </b-form>
    </validation-observer>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    props: ["tahun", "elemenId"],
    data() {
        return {

            Obj: {
                Catatan: `Kenaikan Pangkat ke Gred <GRED>.
Penetapan gaji kenaikan pangkat dari gred <GRED_LAMA> ke gred <GRED_BAHARU>.
TPG: <TPG>`,
            },
            objRowBef: {},
            ServClassList: [],
            SchmOfServList: [],
            SalGrdList: [],
            tpgList: [],
            skimOptions: [{
                    value: '2',
                    text: 'SSPA'
                },
                {
                    value: '1',
                    text: 'SSM'
                },
            ],
        }
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {

            return dirty || validated ? valid : null;
        },
        runMethod() {
            console.log(this.ServClassId);

            let Search = {
                ServClassId: this.Obj.ServClassId,
            };

            GetselenggaraService.getSenaraiSchmOfServ(Search)
                .then((resp) => {
                    this.SchmOfServList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        runMethod2() {
            console.log("this SchmOfServId", this.SchmOfServId);
            let Search2 = {
                ServClassId: this.Obj.ServClassId,
                SchmOfServId: this.Obj.SchmOfServId,
                pilihSkim: this.Obj.id_SistemSaraan,
            };
            console.log("this Search2", this.Search2);
            GetselenggaraService.getSenaraiSalGrd(Search2)
                .then((resp) => {
                    this.SalGrdList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        SimpanMaklumat() {
            this.Obj.coid = Store.state.MaklumatPeribadi.coid;
            this.Obj.tahun = this.tahun;
            this.Obj.elemenId = this.elemenId;
            console.log("logsadsa", this.Obj);

            GetsalaryService.setElemenNaikPangkat(this.Obj).then((resp) => {
                this.StatusSimpan = resp.data;
            }).then(() => {

                console.log("StatusSimpan", this.StatusSimpan);

                if (this.StatusSimpan.Status == 1) {
                    swal
                        .fire({
                            title: "BERJAYA DI SIMPAN!",
                            text: "KLIK OK UNTUK TERUSKAN.",
                            icon: "success",
                        })
                        .then(() => {
                            this.$emit("batal");
                        });
                } else {
                    swal.fire({
                        title: this.StatusSimpan.details,
                        text: "KLIK OK UNTUK TERUSKAN.",
                        icon: "error",
                    }).then(() => {
                        this.$emit("batal");
                    });
                }
            });
        }
    },
    created() {

        GetselenggaraService.getSenaraiServClass()
            .then((resp) => {
                this.ServClassList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        // GetselenggaraService.getSenaraiSchmOfServ(Search)
        //     .then((resp) => {
        //         this.SchmOfServList = resp.data;
        //         //console.log(this.objekList);
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //     });

        // let Search = {
        //     coid: Store.state.MaklumatPeribadi.coid
        // };
        // GetsalaryService.getRowBef(Search)
        //     .then((resp) => {
        //         this.objRowBef = resp.data[0];
        //         this.Obj.ServClassId = this.objRowBef.ServClassId;
        //         //this.Obj.SchmOfServId = this.objRowBef.SchmOfServId;
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //     });

        // this.Obj = this.objRowBef.SalGrdID;
        // this.Obj = this.objRowBef.SchmOfServId;

    }
}
</script>
